(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report', {
            parent: 'entity',
            url: '/patch-report?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report/patch-reports.html',
                    controller: 'PatchReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReport');
                    $translatePartialLoader.addPart('patchStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-detail', {
            parent: 'entity',
            url: '/patch-report/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report/patch-report-detail.html',
                    controller: 'PatchReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReport');
                    $translatePartialLoader.addPart('patchStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReport', function($stateParams, PatchReport) {
                    return PatchReport.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report.new', {
            parent: 'patch-report',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-dialog.html',
                    controller: 'PatchReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                barcode: null,
                                issueDate: null,
                                submitPoint: null,
                                durationInMonths: null,
                                comment: null,
                                patchStatus: null,
                                executedBy: null,
                                executedDate: null,
                                latitude: null,
                                longitude: null,
                                checkDoctor: null,
                                approvalDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('patch-report');
                });
            }]
        })
        .state('patch-report.edit', {
            parent: 'patch-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-dialog.html',
                    controller: 'PatchReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReport', function(PatchReport) {
                            return PatchReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report.delete', {
            parent: 'patch-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report/patch-report-delete-dialog.html',
                    controller: 'PatchReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReport', function(PatchReport) {
                            return PatchReport.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
